import React, { use, useCallback, useEffect, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { Document, Page, pdfjs } from "react-pdf";
import pdfFile from "../../src/pogopin.pdf";

import "react-pdf/dist/Page/TextLayer.css";
import styled from "styled-components";
import { Button, useMediaQuery } from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  mobileCurrentPage,
  pageState,
  pdfPage,
  pdfRef,
  scaleValue,
} from "../atoms";
import { useControls } from "react-zoom-pan-pinch";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import Icon from "@mui/material/Icon";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const PageBox = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px rgba(0, 0, 0, 0.1);
`;
const Pages = React.forwardRef((props, ref) => {
  return (
    <PageBox className="pages" ref={ref}>
      <div>{props.children}</div>
    </PageBox>
  );
});

Pages.displayName = "Pages";

function Flipbook() {
  const [numPages, setNumPages] = useRecoilState(pdfPage);
  const pageFlipRef = useRef();
  const setPageState = useSetRecoilState(pageState);
  const [bookRef, setBookRef] = useRecoilState(pdfRef);
  const { centerView } = useControls();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [mobilePage, setMobilePage] = useRecoilState(mobileCurrentPage);
  const [showModal, setShowModal] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const onFlip = (e) => {
    const currentPage = e.data + 1;
    const totalPages = pageFlipRef.current.pageFlip().getPageCount(); // 전체 페이지 수
    setPageState({ currentPage, totalPages });
  };

  useEffect(() => {
    setTimeout(() => {
      centerView(1, 100, "easeOut");
    }, 100);
  }, []);

  useEffect(() => {
    setBookRef(pageFlipRef.current);
  }, []);

  return (
    <>
      <HTMLFlipBook
        width={595}
        height={841}
        showCover={true}
        flippingTime={500}
        ref={pageFlipRef} // 참조 연결
        onFlip={onFlip}
      >
        {[...Array(numPages).keys()].map((pg) => (
          <Pages key={pg + 1} number={pg + 1}>
            {(pg + 1 === 27 || pg + 1 === 29) && (
              <Button
                style={{
                  position: "absolute",
                  top: pg + 1 === 27 ? "60%" : "62.5%",
                  left: "30%",
                  transform: "translate(-50%,-50%)",
                  zIndex: 10,
                }}
                variant="contained"
                onClick={() => setShowModal(true)}
              >
                Play
              </Button>
            )}
            <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
              <Page
                pageNumber={pg + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          </Pages>
        ))}
      </HTMLFlipBook>
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              position: "relative",
              width: "80%",
              height: "80%",
              background: "#000",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <video
              src="https://www.mempro.co.kr/pogo.mp4"
              controls
              autoPlay
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Flipbook;
